import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Course } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Course with all versions
 * @param course_id
 */
const getCourse = (course_id: string | string[]): Promise<Course> => {
  const tokenId = Cookies.get(AUTH_TOKEN_KEY)
  const URL = routes.COURSE + course_id
  const config = {
    headers: {
      Authorization: `Bearer ${tokenId}`,
    },
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default getCourse
